import { render, staticRenderFns } from "./vendeurChooser.vue?vue&type=template&id=1f3b0145&"
import script from "./vendeurChooser.vue?vue&type=script&lang=ts&"
export * from "./vendeurChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports